// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3TvPA","footer":"ModalUpdate_footer__3ushn"};